import React from "react";
import PropTypes from "prop-types";
import Loader from "./Loader";
import {
    TextWrapper,
    LoaderWrapper,
    Wrapper,
    ResponsiveText,
} from "./Loading.styles";

const Loading = ({ text }) => {
    return (
        <Wrapper>
            <LoaderWrapper>
                <Loader />
            </LoaderWrapper>
            {text && (
                <TextWrapper>
                    <ResponsiveText variant="smallLight">{text}</ResponsiveText>
                </TextWrapper>
            )}
        </Wrapper>
    );
};

Loading.propTypes = {
    text: PropTypes.string,
};

export default Loading;
